module.exports = __webpack_public_path__ + "static/image4-ec174e74d9e9c8684888ccea98349d5e.png";